/** Angular */
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { BYD_RUNTIME_INJECTION_TOKEN } from '../configs/byd-api-injection-token';
/** Models */
import { BydRuntime } from '../models/byd-runtime';

@Injectable({
  providedIn: 'root',
})
export class BydRuntimeService<T> {
  /**
   * The application environment configuration.
   */
  public environment: T;

  /**
   * Creates an instance of BydRuntimeService.
   *
   * @param bydRuntime the beyond run time environment injected configuration
   */
  // TODO Set the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(@Optional() @Inject(BYD_RUNTIME_INJECTION_TOKEN) public bydRuntime?: BydRuntime<T> | any) {
    this.bydRuntime = new BydRuntime(bydRuntime);
  }

  /**
   * Retrieve the environment configuration data from the injected file location.
   *
   * @default location file "/assets/environments/environment.json"
   * @returns The Application environment Promise<T>
   */
  public getBydEnvironment(): Promise<T> {
    return new Promise<T>((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', this.bydRuntime.url, false);
      /**
       * @returns T
       */
      xhr.onload = () => {
        if (xhr.status === 200) {
          this.environment = JSON.parse(xhr.response);
          if (this.bydRuntime.environment) this.replaceBydEnvironment(this.bydRuntime.environment, this.environment);

          resolve(JSON.parse(xhr.responseText));
          return this.environment;
        }
        throw new Error(`${this.bydRuntime.url} ${xhr.statusText}`);
      };
      xhr.send();
    });
  }

  /**
   * Load environment from the injected file location.
   *
   * @returns Observable<T>
   */
  public loadBydEnvironment(): Observable<T> {
    return new Observable<T>((subscriber) => {
      this.getBydEnvironment().then((environment) => {
        subscriber.next(environment);
        subscriber.complete();
      });
    });
  }

  /**
   * Replace the compile time with the runtime environment.
   *
   * @param compileTimeEnvironment the angular environment compile-time
   * @param runTimeEnvironment the angular environment runtime
   */
  private replaceBydEnvironment(compileTimeEnvironment: T, runTimeEnvironment: T): void {
    Object.keys(compileTimeEnvironment).forEach((key) => {
      if (typeof compileTimeEnvironment[key] === 'object') {
        this.replaceBydEnvironment(compileTimeEnvironment[key], runTimeEnvironment[key]);
      } else {
        compileTimeEnvironment[key] = runTimeEnvironment[key];
      }
    });
  }
}
